import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import get from "lodash/get";
import { isEmpty } from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import {
  selectDataModels,
  selectSelectedDataModel,
  setSelectedDataModelId,
  selectSwaggerData,
} from "./index";
import { EmptyLayout } from "../../components/molecules";
import { renderNoDataModelLayout } from "../../helpers";
import { hashTagIcon } from "../../assets/icons";
import Spinner, { SPINNER_NAMES } from "../../components/organisms/Spinner";

const { FETCH_MULESOFT_SWAGGER_DATA } = SPINNER_NAMES;
const STATUS = "status";
const ACTIVE = "active";

const ApiDocs = () => {
  const dispatch = useDispatch();
  const { dataModelId } = useParams();
  const navigate = useNavigate();

  const selectedDataModel = useSelector(selectSelectedDataModel);
  const { data: dataModels } = useSelector(selectDataModels);
  const swaggerData = useSelector(selectSwaggerData);

  const [currentDataModel, setCurrentDataModel] = useState(selectedDataModel);

  const isAnyDeployedEndpointExists = !isEmpty(get(swaggerData,"paths"));
  const isDataModelStatusActive = isAnyDeployedEndpointExists && get(currentDataModel, STATUS) === ACTIVE;

  useEffect(() => {
    dataModels.forEach((datamodel) => {
      if (datamodel.id === dataModelId) setCurrentDataModel(datamodel);
    });
  }, [dataModels, dataModelId]);

  useEffect(() => {
    if (!selectedDataModel && dataModelId)
      dispatch(setSelectedDataModelId(dataModelId));
  }, [dispatch, dataModelId, selectedDataModel]);

  const renderApiDocs = () => (
    <>
      <div className="flex-col xs:flex-row flex mb-4 gap-4" />
      {isDataModelStatusActive ? (
        <div className="bg-gray-100 p-1">
          <SwaggerUI spec={swaggerData} />
        </div>
      ) : (
        <div className="content overflow-auto p-6 flex-1">
          <EmptyLayout
            title="Deploy Backend app to see the API docs"
            subTitle="Swagger Data "
            shouldShowButton={false}
            image={hashTagIcon}
          />
        </div>
      )}
    </>
  );

  return (
    <div className="content scrollbar overflow-auto p-6 flex-1">
      <Helmet>
        <title>ApiDocs | TavaJS</title>
      </Helmet>
      <div className="flex-col flex mb-4 gap-4">
        <Spinner name={FETCH_MULESOFT_SWAGGER_DATA}>
          {selectedDataModel
            ? renderApiDocs()
            : renderNoDataModelLayout(navigate)}
        </Spinner>
      </div>
    </div>
  );
};

export default ApiDocs;
